import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { useState } from 'react';
import { roles } from '../../Shared/userManagmentOptions';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Password } from 'primereact/password';

export const AddNewUser = ({ createNewUser, schoolsOptions }) => {
    const [formData, setFormData] = useState({
        egn: '',
        username: '',
        password: '',
        name: '',
        phoneNumber: '',
        email: '',
        userRole: null,
        school: { id: 0 },
        isActive: true,
        changeGrao: false
    })
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name == 'isActive' || name == "changeGrao") {
            setFormData({ ...formData, [name]: e.target.checked });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    return (
        <div className="form-group mt-4">
            <div className="input-row d-flex gap-3 flex-wrap justify-content-between">

                <div className="input-group w-48">
                    <span className="p-float-label labels">
                        <InputText name='egn' id="egn" style={{ width: '100%' }} value={formData.egn} onChange={handleChange} />
                        <label htmlFor="egn">ЕГН *</label>
                    </span>
                </div>

                <div className="input-group w-48">
                    <span className="p-float-label labels">
                        <InputText name='name' id="name" style={{ width: '100%' }} value={formData.name} onChange={handleChange} />
                        <label htmlFor="name">Име *</label>
                    </span>
                </div>

                <div className="input-group w-48">
                    <span className="p-float-label labels">
                        <InputText name='username' id="username" style={{ width: '100%' }} value={formData.username} onChange={handleChange} />
                        <label htmlFor="username">Потребителско име *</label>
                    </span>
                </div>

                <div className="input-group w-48">
                    <span className="p-float-label labels">
                        <Password
                            inputId="pass"
                            name='password'
                            value={formData.password}
                            onChange={handleChange}
                            feedback={false}
                            toggleMask
                            className={`${formData.password.length > 5 || formData.password === '' ? '' : 'p-invalid'} w-100`}
                        />
                        <label htmlFor="pass">Парола *</label>
                    </span>
                </div>

                <div className="input-group w-48 mt-2">
                    <span className="p-float-label labels">
                        <InputText name='phoneNumber' id="phoneNumber" style={{ width: '100%' }} value={formData.phoneNumber} onChange={handleChange} />
                        <label htmlFor="phoneNumber">Мобилен номер *</label>
                    </span>
                </div>

                <div className="input-group w-48 mt-2">
                    <span className="p-float-label labels">
                        <InputText name='email' id="email" style={{ width: '100%' }} value={formData.email} onChange={handleChange} />
                        <label htmlFor="userRole">e-mail адрес *</label>
                    </span>
                </div>

        

                <div className="input-group w-48 mt-2">
                    <span className="p-float-label labels">
                        <Dropdown value={formData.userRole} name="userRole" onChange={handleChange} options={roles} optionLabel="name" className="w-100" />
                        <label htmlFor="userRole">Роля на потребител *</label>
                    </span>
                </div>

                <div className="input-group w-48 mt-2">
                    <span className="p-float-label labels">
                        <Dropdown value={formData.school} name="school" onChange={handleChange} options={schoolsOptions} optionLabel="name" className="w-100" />
                        <label htmlFor="school">Училище *</label>
                    </span>
                </div>

                <div className="input-group w-100 mt-2 d-flex">
                    <div className="w-20 d-flex gap-2">
                        <label >Статус - Активен</label>
                        <Checkbox name="isActive" checked={formData.isActive} onChange={handleChange} />
                    </div>

                    <div className="w-30 d-flex gap-2">
                        <label >Достъп до промяна на адрес</label>
                        <Checkbox name="changeGrao" checked={formData.changeGrao} onChange={handleChange} />
                    </div>
                </div>

                <div className="w-100 d-flex justify-content-end">
                    <Button label="Добави потребител" icon="pi pi-user-plus" onClick={(e) => createNewUser(e, formData)} className='btn-prim-confirm' />
                </div>

            </div>
        </div>
    )
}